import { Square, Text, VStack } from "@chakra-ui/react";
import { COLUMN_HEADER_HEIGHT, DAY_STRIP_WIDTH } from "@src/constants/planning";
import { format, isToday } from "date-fns";
import type { FunctionComponent } from "react";

type DayStripProps = {
  day: Date;
};

export const DayStrip: FunctionComponent<DayStripProps> = ({ day }) => {
  return (
    <VStack
      pos="sticky"
      zIndex="11"
      top={COLUMN_HEADER_HEIGHT}
      left="0"
      w={DAY_STRIP_WIDTH}
      pt="1"
      bg="white"
      borderColor="grey.100"
      borderRightWidth="2px"
      borderRightColor={
        day.toDateString() === new Date().toDateString()
          ? "blue.500"
          : "grey.100"
      }
      borderBottomWidth="1px"
      id={day.toDateString()}
    >
      <Text color="grey.500" fontSize="xs" fontWeight="semibold">
        {format(day, "E")}
      </Text>
      <Square bg={isToday(day) ? "teal.200" : "grey.100"} rounded="md" size="8">
        <Text
          color={`${isToday(day) ? "teal" : "grey"}.700`}
          fontSize="md"
          fontWeight="semibold"
        >
          {format(day, "d")}
        </Text>
      </Square>
    </VStack>
  );
};
